import { Box, Typography } from '@mui/material';

type Variant = 'info' | 'warn' | 'success' | 'error';

const VARIANTS: Record<Variant, { bg: string; border: string; fg: string }> = {
  info: {
    bg: 'var(--pm-bg-accent)',
    border: 'var(--pm-primary)',
    fg: 'var(--pm-fg-base)',
  },
  warn: {
    bg: 'rgba(251, 191, 36, 0.12)',
    border: 'var(--pm-warning)',
    fg: 'var(--pm-fg-base)',
  },
  success: {
    bg: 'rgba(52, 211, 153, 0.12)',
    border: 'var(--pm-success)',
    fg: 'var(--pm-fg-base)',
  },
  error: {
    bg: 'rgba(248, 113, 113, 0.12)',
    border: 'var(--pm-error)',
    fg: 'var(--pm-fg-base)',
  },
};

interface PmInfoBoxProps {
  variant?: Variant;
  title?: string;
  children: React.ReactNode;
}

/** PM-InfoBox — farblich abgesetzte Hinweis-Kachel mit linker Akzent-Leiste. */
export function PmInfoBox({ variant = 'info', title, children }: PmInfoBoxProps) {
  const v = VARIANTS[variant];
  return (
    <Box
      sx={{
        background: v.bg,
        color: v.fg,
        borderLeft: `3px solid ${v.border}`,
        borderRadius: '0 var(--pm-radius) var(--pm-radius) 0',
        padding: '12px 16px',
      }}
    >
      {title && (
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5, color: v.border }}>
          {title}
        </Typography>
      )}
      <Box sx={{ fontSize: '0.875rem', lineHeight: 1.5 }}>{children}</Box>
    </Box>
  );
}
